/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { communeSchema } from "./communeSchema.ts";
import { departmentsSchema } from "./departmentsSchema.ts";
import { neighborhoodsSchema } from "./neighborhoodsSchema.ts";
import { z } from "zod";

export const addressSchema = z.object({
      "city": z.string().min(1).max(255).optional(),
  "postalCode": z.string().min(1).max(255).optional(),
  "street": z.string().min(1).max(255).describe("Numéro exclu (`number`). Obligatoire dès qu'une adresse est enregistrée (`required` côté entité).").optional(),
  "department": z.lazy(() => departmentsSchema).optional(),
  "commune": z.lazy(() => communeSchema).optional(),
  "neighborhood": z.lazy(() => neighborhoodsSchema).optional(),
  "latitude": z.number().optional(),
  "longitude": z.number().optional(),
  "number": z.string().optional(),
  "complement": z.string().max(255).describe("Informations complémentaires (bâtiment, résidence, étage…), texte libre.").optional(),
  "codeInsee": z.string().max(5).describe("Code INSEE de la commune, issu de la suggestion d'adresse ; clé des quartiers du datalake.").optional(),
  "quartierOid": z.string().max(50).describe("Identifiant (`oid`) du quartier choisi dans le datalake, vidé si la commune change.").optional()
      })